import { atom } from 'jotai';
import { getMapDefaultConfig } from 'components/map/atoms';
import type { MapUserConfig } from 'components/map/types';
import type { MatchStatus } from './types';

// Origin vs Target membership colors — matched to the sidebar legend.
export const MATCH_COLORS: Record<MatchStatus, string> = {
  matched: '#0f62fe', // In Both
  unmatched_a: '#8a3800', // Only in Origin
  unmatched_b: '#198038', // Only in Target
};

/**
 * A per-instance map config that starts from the defaults but silences every
 * global layer, so only the comparison's own wells and unit boundaries draw
 * (mirrors SubtractMap). Each map instance gets its own atom.
 * @return {object} A jotai atom holding the silenced map config
 */
export const buildComparisonMapConfigAtom = () => {
  const defaultConfig = getMapDefaultConfig();
  return atom({
    ...defaultConfig,
    wells: { ...defaultConfig.wells, checked: false },
    wellsV2: { ...defaultConfig.wellsV2, checked: false },
    developmentAreas: {
      ...defaultConfig.developmentAreas,
      options: {
        ...defaultConfig.developmentAreas.options,
        horizontalUnits: false,
        verticalUnits: false,
        fieldUnits: false,
        pricing: false,
      } as MapUserConfig['developmentAreas']['options'],
    },
    titleEntityAssets: { ...defaultConfig.titleEntityAssets, checked: false },
    basinTier: { ...defaultConfig.basinTier, checked: false },
    scrollZoom: { checked: true },
    popups: { checked: false },
    focusAreas: { checked: false, selections: {} },
  });
};
